import { IntegrationType } from '@grouper/modules/core/integrationTypes'
import LocalGrouperForm from '@grouper/modules/integrations/localGrouper/components/integrations/LocalGrouperForm'
import localGrouperIntegration from '@grouper/modules/integrations/localGrouper/assets/images/localGrouperIntegration.svg?url'

export class LocalGrouperIntegrationType extends IntegrationType {
  static getType() {
    return 'local_grouper'
  }

  get name() {
    return this.app.$i18n.t('integrationType.localGrouper')
  }

  get image() {
    return localGrouperIntegration
  }

  get iconColor() {
    return 'darker-blue'
  }

  getSummary(integration) {
    if (!integration.authorized_user) {
      return this.app.$i18n.t('localGrouperIntegrationType.localGrouperNoUser')
    }

    return this.app.$i18n.t('localGrouperIntegrationType.localGrouperSummary', {
      name: integration.authorized_user.first_name,
      username: integration.authorized_user.username,
    })
  }

  get formComponent() {
    return LocalGrouperForm
  }

  get warning() {
    return this.app.$i18n.t('localGrouperIntegrationType.localGrouperWarning')
  }

  getDefaultValues() {
    const user = this.app.$store.getters['auth/getUserObject']
    return {
      authorized_user: { username: user.username, first_name: user.first_name },
    }
  }

  getOrder() {
    return 10
  }
}
